export const TEMP_STORED_PRODUCT_DATA = (productCode: string = '') =>
  `tempStoredProductData-${productCode}`;

export const TEMP_STORED_PRODUCT_FILE = (productCode: string = '') =>
  `tempStoredProductFile-${productCode}`;

export const dataURLtoFile = (
  dataurl: string,
  filename: string,
): File | undefined => {
  try {
    if (!dataurl || typeof dataurl !== 'string') return undefined;
    const base64Index = dataurl.indexOf(';base64,');
    if (base64Index === -1) return undefined;
    const mime = dataurl.substring(5, base64Index);
    const bstr = atob(dataurl.substring(base64Index + 8));
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  } catch (e) {
    console.error('Failed to restore file from dataURL:', e);

    return undefined;
  }
};

export const normalizeValue = (val: unknown): unknown => {
  if (val === null || val === undefined || val === '') return '';
  if (val instanceof File) return val;
  if (Array.isArray(val)) return val.map(normalizeValue);
  if (typeof val === 'object') {
    return Object.fromEntries(
      Object.entries(val as object).map(([k, v]) => [k, normalizeValue(v)]),
    );
  }

  return val;
};

export const stripDisplayFields = ({
  product_category_names: _product_category_names,
  ...values
}: any) => ({
  ...values,
  productVariations: values.productVariations?.map(
    ({
      productVariantName: _productVariantName,
      productFlavorName: _productFlavorName,
      variation_template: _variation_template,
      variation_template_id: _variation_template_id,
      modified_at: _modified_at,
      created_at: _created_at,
      ...rest
    }: any) => rest,
  ),
});
